import { OrganizationKeyName } from "../../model/Organization";

export enum ObjectiveType {
  ORDER_CREATED = "order_created",
  ORDER_DELIVERED_NO_GIFT_CARD = "order_delivered_no_gift_card",
  ORDER_DELIVERED_FIRST_TIME = "order_delivered_first_time",
  ORDER_DELIVERED_ORDER_COUNT = "order_delivered_order_count",
  ORDER_DELIVERED_PRODUCT_COUNT = "order_delivered_product_count",
}

export interface ChallengeType {
  _type?: string;
  id?: string;
  organizationKeyName?: OrganizationKeyName;
  name: string;
  sortKey?: number;
  activeFrom: string;
  recurring: boolean;
  enabled: boolean;
  isInUse: boolean;
  autoClaimReward: boolean;
  version: number;
  title: string;
  description: string;
  imageUrl: string;
  activeExpiresAt: string;
  completedExpiresAt: string;
  objectiveType: ObjectiveType;
  objectiveGoal: number;
  objectiveProductId?: string | null;
  rewardProductId: string;
  prerequisiteChallengeId?: string | null;
  currency?: string;
  countryCode: string;
}

export interface ChallengeFormType extends ChallengeType {
  hasPrerequisite?: boolean;
  files: File[];
}

export type DeleteChallengeType = {
  organizationKeyName: OrganizationKeyName;
  id: string;
};

export interface ChallengesResponse {
  challenges: ChallengeType[];
}

export interface ChallengeResponse {
  data: ChallengeType;
}

type Reward = {
  image_url: string;
  title: string;
  validity_duration: string;
};

export type UserChallenge = {
  _type: string;
  active_expires_at: string;
  completed_expires_at: string;
  description: string;
  id: string;
  image_url: string;
  objective_goal: number;
  objective_progress: number;
  objective_type: string;
  reward: Reward;
  state: string;
  title: string;
};

export type UserChallengeApiResponse = {
  challenges: UserChallenge[];
};
